// removed by extract-text-webpack-plugin
module.exports = {"plan-scorecard-company-resolution":"plan-scorecard-company-resolution___13VHh h3___5u0xZ","anchor":"anchor___2xE1p","section-slidedown-button":"section-slidedown-button___UFgRh center___2iqBf","section-slidedown-label":"section-slidedown-label___1e4q0 h1___3_4RF","section-slidedown-icon":"section-slidedown-icon___32WLO h1___3_4RF","resolution-section-title":"resolution-section-title___2wdJw h2___hzLuT","sidebar-button":"sidebar-button___2Sqnu h2___hzLuT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardShareholderResolution/PlanScorecardShareholderResolution.css
// module id = 910
// module chunks = 0